/* Pain Relief Depot cart extras. Places the server-rendered block from sections/prd-cart-extras.liquid
   into the cart drawer (and the cart page) and handles the two "Add" buttons. */
(function () {
  if (window.__prdCartExtras) return;
  window.__prdCartExtras = true;

  var observer = null;
  var timer = null;
  var busy = false;
  var loading = false;

  function onCartPage() {
    return /^\/cart\/?$/.test(window.location.pathname);
  }

  function targets() {
    var list = [];
    var footer = document.querySelector('cart-drawer .drawer__footer');
    var items = document.querySelector('cart-drawer cart-drawer-items');
    if (footer) list.push({ part: 'ship', parent: footer, before: footer.querySelector('.cart-drawer__footer') || footer.firstChild, note: footer });
    if (items) list.push({ part: 'more', parent: items, before: null });
    var blocks = document.querySelector('.cart__footer .cart__blocks');
    if (blocks && blocks.parentNode) {
      list.push({ part: 'ship', parent: blocks.parentNode, before: blocks });
      list.push({ part: 'more', parent: blocks.parentNode, before: blocks });
    }
    return list;
  }

  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    if (!observer) {
      observer = new MutationObserver(function () { schedule(); });
    }
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function unwatch() {
    if (observer) observer.disconnect();
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  function place(source) {
    unwatch();
    var old = document.querySelectorAll('.pce-slot');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    var flagged = document.querySelectorAll('.pce-hide-note');
    for (var k = 0; k < flagged.length; k++) flagged[k].classList.remove('pce-hide-note');
    var style = source ? source.querySelector('style') : null;
    if (source && style) {
      var list = targets();
      for (var j = 0; j < list.length; j++) {
        var part = source.querySelector('[data-pce-part="' + list[j].part + '"]');
        if (!part) continue;
        var slot = document.createElement('div');
        slot.className = 'pce-slot';
        slot.innerHTML = style.outerHTML + part.outerHTML;
        list[j].parent.insertBefore(slot, list[j].before);
        if (list[j].note) list[j].note.classList.add('pce-hide-note');
      }
    }
    watch();
  }

  function refresh() {
    if (loading) return;
    loading = true;
    fetch('/?section_id=prd-cart-extras', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        loading = false;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.getElementById('prd-cart-extras');
        if (!source) return;
        var goods = Number(source.getAttribute('data-goods') || 0);
        var key = source.getAttribute('data-priority-key');
        if (goods === 0 && key) {
          removeLine(key);
          return;
        }
        place(source);
      })
      .catch(function () { loading = false; });
  }

  function sectionsPayload() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return null;
  }

  function render(state) {
    var drawer = document.querySelector('cart-drawer');
    if (!onCartPage() && drawer && state && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
      schedule();
    } else {
      window.location.reload();
    }
  }

  function removeLine(key) {
    var body = { id: key, quantity: 0 };
    var sections = sectionsPayload();
    if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function () { window.location.reload(); }).catch(function () {});
  }

  function fail(button, message) {
    busy = false;
    button.disabled = false;
    button.textContent = 'Add';
    var row = button.parentNode;
    var note = row.querySelector('.pce-err');
    if (!note) {
      note = document.createElement('span');
      note.className = 'pce-err';
      var text = row.querySelector('.pce-row__text');
      (text || row).appendChild(note);
    }
    note.textContent = message || 'Sorry, that could not be added. Please try again.';
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-pce-add]') : null;
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    button.disabled = true;
    button.textContent = 'Adding';

    var item = { id: Number(button.getAttribute('data-variant')), quantity: 1 };
    var plan = button.getAttribute('data-plan');
    if (plan) item.selling_plan = Number(plan);
    var code = button.getAttribute('data-code');

    var before = code
      ? fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {})
      : Promise.resolve();

    before
      .then(function () {
        var body = { items: [item] };
        var sections = sectionsPayload();
        if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.status) { fail(button, state.description || state.message); return; }
        busy = false;
        render(state);
      })
      .catch(function () { fail(button); });
  });

  function start() {
    refresh();
    watch();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
